import {
  addDoc,
  collection,
  getDocs,
  orderBy,
  query,
  serverTimestamp,
  updateDoc,
} from "firebase/firestore";
import { database } from "../../lib/cliente";
import { Atividade } from "../../types";

const AtividadesCollection = collection(database, "atividades");

export class AtividadesServiceClass {
  private static _instance: AtividadesServiceClass;

  static getInstace(): AtividadesServiceClass {
    if (!this._instance) {
      this._instance = new AtividadesServiceClass();
    }
    return this._instance;
  }

  async getAtividades(): Promise<Atividade[] | undefined> {
    try {
      const atividadesQuery = query(
        AtividadesCollection,
        orderBy("createdAt", "desc")
      );
      const atividades = await getDocs(atividadesQuery);

      return atividades.docs.map((doc) => ({
        ...doc.data(),
      })) as Atividade[];
    } catch (err) {
      console.log(err);
    }
  }

  async addAtividade(atividade: string) {
    const docRef = await addDoc(AtividadesCollection, {
      atividade: atividade,
      createdAt: serverTimestamp(),
    });

    await updateDoc(docRef, {
      id: docRef.id,
    });
  }
}

export const AtividadesService = AtividadesServiceClass.getInstace();
